export default {
  PERSONAL_INFO: 'personal_info',
};
